import React from 'react';
import { FaHandshake, FaTools } from "react-icons/fa";
import { HiLightBulb } from "react-icons/hi";
import '../styles/howitworks.scss';

const ProcessStep = ({ number, Icon, title, description }) => (
    <div className="process-step">
        <div className="step-icon-container">
            <div className="step-circle">
                <Icon className="step-icon" />
                <span className="step-number">{number}</span>
            </div>
        </div>
        <h3 className="step-title">{title}</h3>
        <p className="step-description">{description}</p>
    </div>
);

const HowItWorks = () => (
    <section className="how-it-works-section">
        <div className="container">
            <h2 className="section-heading">How We Bring Your Custom Vision to Life</h2>
            <p className="section-subheading">
                Artiza connects your unique design ideas with the best local artisans for bespoke furniture and decor.
            </p>

            <div className="process-grid">
                <ProcessStep
                    number="1"
                    Icon={HiLightBulb}
                    title="Share Your Idea"
                    description="Submit a sketch, a mood board, or simply a detailed description of what you envision."
                />
                <ProcessStep
                    number="2"
                    Icon={FaHandshake}
                    title="Get Matched"
                    description="Our team pairs your project with vetted artisans whose skills and materials align with your requirements."
                />
                <ProcessStep
                    number="3"
                    Icon={FaTools}
                    title="See It Created"
                    description="Work directly with the artisan on the details, track the crafting process, and receive your unique piece."
                />
            </div>

            <div className="cta-wrapper">
                <a href="/login" className="cta-button">
                    Start Your Custom Project Today
                </a>
            </div>
        </div>
    </section>
);

export default HowItWorks;
